import styled from 'styled-components';
import {
  BREAKPOINT,
  MARGIN,
  PADDING,
  REBRAND_COLOR
} from '@latitude/core/utils/constants';
import Section from '@latitude/section-rebrand';

export const StyledSection = styled(Section)`
  .link-block {
    color: ${REBRAND_COLOR.INDIGO} !important;
    background-color: ${REBRAND_COLOR.WHITE};
    border: 1px solid ${REBRAND_COLOR.BLACK_40};
    border-radius: 8px;
  }
  .is-open {
    position: relative;
    border-bottom: 1px solid ${REBRAND_COLOR.BLACK_40};
    border-top: 1px solid ${REBRAND_COLOR.WHITE};
    border-radius: 8px;
  }
    /* Left border */
  .is-open::before {
    content: "";
    position: absolute;
    top: 56px;
    bottom: 4.2px;
    left: 0;
    width: 1px;
    background-color:  ${REBRAND_COLOR.BLACK_40};
  }
  /* Right border */
  .is-open::after {
    content: "";
    position: absolute;
    top: 56px;
    right: 0;
    bottom: 4.2px;
    width: 1px;
    background-color:  ${REBRAND_COLOR.BLACK_40};
  }
    .accordion__item {
    margin-bottom: ${MARGIN.M16};
    
  .rich-text {
    b {
      font-weight: 500;
    }
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  gap: 20px;
  padding-top: 3px;
  justify-content: space-between;
  background-color: ${REBRAND_COLOR.WHITE};
  border-bottom: ${({ addBorder }) =>
    addBorder ? `1px solid ${REBRAND_COLOR.STONE}` : 'none'};
  & > div:nth-of-type(2) {
    text-align: right;
    @media (min-width: 760px) {
      width:70%;
    }
  }
`;